import {
  createProjectItem as publicCreateProjectItem,
  bulkCreateProjectItems as publicBulkCreateProjectItems,
  getProjectItem as publicGetProjectItem,
  listProjectItems as publicListProjectItems,
  updateProjectItem as publicUpdateProjectItem,
  bulkUpdateProjectItems as publicBulkUpdateProjectItems,
  deleteProjectItem as publicDeleteProjectItem,
  bulkDeleteProjectItems as publicBulkDeleteProjectItems,
  duplicateProjectItems as publicDuplicateProjectItems,
  generateTokenForProjectItems as publicGenerateTokenForProjectItems,
} from './portfolio-project-items-v1-project-item-project-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onProjectItemCreated as publicOnProjectItemCreated } from './portfolio-project-items-v1-project-item-project-items.public.js';
import { onProjectItemDeleted as publicOnProjectItemDeleted } from './portfolio-project-items-v1-project-item-project-items.public.js';
import { onProjectItemUpdated as publicOnProjectItemUpdated } from './portfolio-project-items-v1-project-item-project-items.public.js';

export const createProjectItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateProjectItem> &
    typeof publicCreateProjectItem
> = /*#__PURE__*/ createRESTModule(publicCreateProjectItem);
export const bulkCreateProjectItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateProjectItems> &
    typeof publicBulkCreateProjectItems
> = /*#__PURE__*/ createRESTModule(publicBulkCreateProjectItems);
export const getProjectItem: MaybeContext<
  BuildRESTFunction<typeof publicGetProjectItem> & typeof publicGetProjectItem
> = /*#__PURE__*/ createRESTModule(publicGetProjectItem);
export const listProjectItems: MaybeContext<
  BuildRESTFunction<typeof publicListProjectItems> &
    typeof publicListProjectItems
> = /*#__PURE__*/ createRESTModule(publicListProjectItems);
export const updateProjectItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateProjectItem> &
    typeof publicUpdateProjectItem
> = /*#__PURE__*/ createRESTModule(publicUpdateProjectItem);
export const bulkUpdateProjectItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateProjectItems> &
    typeof publicBulkUpdateProjectItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateProjectItems);
export const deleteProjectItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteProjectItem> &
    typeof publicDeleteProjectItem
> = /*#__PURE__*/ createRESTModule(publicDeleteProjectItem);
export const bulkDeleteProjectItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteProjectItems> &
    typeof publicBulkDeleteProjectItems
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteProjectItems);
export const duplicateProjectItems: MaybeContext<
  BuildRESTFunction<typeof publicDuplicateProjectItems> &
    typeof publicDuplicateProjectItems
> = /*#__PURE__*/ createRESTModule(publicDuplicateProjectItems);
export const generateTokenForProjectItems: MaybeContext<
  BuildRESTFunction<typeof publicGenerateTokenForProjectItems> &
    typeof publicGenerateTokenForProjectItems
> = /*#__PURE__*/ createRESTModule(publicGenerateTokenForProjectItems);
/**
 * Triggered when a project item is created.
 */
export const onProjectItemCreated: BuildEventDefinition<
  typeof publicOnProjectItemCreated
> &
  typeof publicOnProjectItemCreated = createEventModule(
  publicOnProjectItemCreated
);
/**
 * Triggered when a project item is deleted.
 */
export const onProjectItemDeleted: BuildEventDefinition<
  typeof publicOnProjectItemDeleted
> &
  typeof publicOnProjectItemDeleted = createEventModule(
  publicOnProjectItemDeleted
);
/**
 * Triggered when a project item is updated.
 */
export const onProjectItemUpdated: BuildEventDefinition<
  typeof publicOnProjectItemUpdated
> &
  typeof publicOnProjectItemUpdated = createEventModule(
  publicOnProjectItemUpdated
);

export {
  Type,
  ImageType,
  SortOrder,
  WebhookIdentityType,
} from './portfolio-project-items-v1-project-item-project-items.universal.js';
export {
  Item,
  ItemMetadataOneOf,
  Image,
  Point,
  UnsharpMasking,
  Video,
  VideoResolution,
  Tags,
  Link,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateProjectItemRequest,
  CreateProjectItemResponse,
  BulkCreateProjectItemsRequest,
  BulkCreateProjectItemsResponse,
  BulkCreateProjectItemResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetProjectItemRequest,
  GetProjectItemResponse,
  ListProjectItemsRequest,
  Paging,
  ListProjectItemsResponse,
  PagingMetadataV2,
  Cursors,
  QueryProjectItemsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryProjectItemsResponse,
  UpdateProjectItemRequest,
  UpdateProjectItemResponse,
  BulkUpdateProjectItemsRequest,
  MaskedItem,
  BulkUpdateProjectItemsResponse,
  BulkUpdateProjectItemResult,
  DeleteProjectItemRequest,
  DeleteProjectItemResponse,
  BulkDeleteProjectItemsRequest,
  BulkDeleteProjectItemsResponse,
  BulkDeleteProjectItemResult,
  CreateProjectGalleryRequest,
  CreateProjectGalleryResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  DeletedProjectRestored,
  DuplicateProjectItemsRequest,
  DuplicateProjectItemsResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GenerateTokenForProjectItemsRequest,
  GenerateTokenForProjectItemsResponse,
  ProjectItemMediaToken,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ProjectItemCreatedEnvelope,
  ProjectItemDeletedEnvelope,
  ProjectItemUpdatedEnvelope,
  BulkCreateProjectItemsOptions,
  ListProjectItemsOptions,
  UpdateProjectItem,
  BulkUpdateProjectItemsOptions,
  BulkDeleteProjectItemsOptions,
  DuplicateProjectItemsOptions,
} from './portfolio-project-items-v1-project-item-project-items.universal.js';
export {
  TypeWithLiterals,
  ImageTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './portfolio-project-items-v1-project-item-project-items.universal.js';
